import React from 'react'
import Card from '@components/Card'
import { colors } from '@lib/colors'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import Show from '@components/Show'
import { i18n } from '@lib/i18n'

const COPY = i18n.en.WORK_ORDERS.LIST
interface WorkOrderCardProps {
  onPress?: () => void
  workOrder: WorkOrder
}

const months = i18n.en.GENERAL.MONTHS

const parseDate = (dateString: string) => {
  const date = new Date(dateString)

  const month = months[date.getMonth()]
  const day = date.getDate()
  const hours = date.getHours()
  const minutes = date.getMinutes()

  // switch (lang) {
  //   case 'en':
  //     return `${month}, ${day}${dateSuffix(day)} ${COPY.AT} ${hours}:${minutes}`
  //   case 'es':
  //     return `${day} de ${month} ${COPY.AT} ${hours}:${minutes}`
  //   case 'de':
  //     (...)
  // }

  return `${month}, ${day}${dateSuffix(day)} ${COPY.CARDS.AT} ${hours}:${minutes}`
}

const dateSuffix = (day: number) => {
  const lastDigit = day.toString().split('').pop()
  switch (lastDigit) {
    case '1':
      return 'st'
    case '2':
      return 'nd'
    default:
      return 'th'
  }
}

const getStatusColor = (status: string) => {
  switch (status) {
    case 'In Progress':
      return { backgroundColor: colors.blue[500] }
    case 'Active':
      return { backgroundColor: colors.purple[500] }
    case 'Work Completed':
      return { backgroundColor: colors.green[500] }
    case 'Draft':
      return { backgroundColor: colors.gray[600] }
  }
}

export default function (props: WorkOrderCardProps) {
  const { onPress, workOrder } = props

  return (
    <Pressable onPress={ onPress }>
      <Card style={ styles.workOrderCard }>
        <View style={ styles.workOrderCardHeader }>
          <Text style={ styles.workOrderCardTitle }>
            WO #{workOrder.workOrderNumber} - { COPY.CARDS.SUBMITTED_ON } { parseDate(workOrder.createdAt) }
          </Text>
          <View style={{ ...styles.workOrderCardStatusPill, ...getStatusColor(workOrder.status.name) }}>
            <Text style={styles.workOrderCardStatusText}>
              { workOrder?.status?.name ? COPY.STATUS[workOrder.status.name] : COPY.STATUS.Draft }
            </Text>
          </View>
        </View>

        <Show
          when={workOrder.description}
          fallback={
            <Text style={ styles.workOrderCardNoDescription }>
              { COPY.CARDS.NO_DESCRIPTION }
            </Text>
          }
        >
          <Text style={ styles.workOrderCardDescription }>
            { workOrder.description }
          </Text>
        </Show>
      </Card>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  // Work order card
  workOrderCard: {
    marginTop: 10,
    padding: 10,
  },
  workOrderCardHeader: {
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  workOrderCardStatusPill: {
    marginLeft: 8,
    padding: 4,
    borderRadius: 2,
    alignSelf: 'flex-start',
  },
  workOrderCardStatusText: {
    color: colors.white,
    fontSize: 12.8,
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  workOrderCardTitle: {
    flex: 1,
    color: colors.blue[500],
    fontSize: 12.8,
    marginBottom: 5,
  },
  workOrderCardDescription: {
    color: colors.gray[500],
    fontSize: 12.8,
  },
  workOrderCardNoDescription: {
    color: colors.gray[200],
    fontSize: 12.8,
    fontStyle: 'italic',
  },
})
